// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Foc5E","fullView":"styles_fullView__1ZKNn"};